import { useEffect } from 'react';
import AdminSTGSvg from '../assets/Admin_STG.svg';
import AdminPreSvg from '../assets/Admin_Pre.svg';
import ClientSTGSvg from '../assets/Client_STG.svg';
import ClientPreSvg from '../assets/Client_Pre.svg';

export const useFavicon = (type: 'admin' | 'client') => {
  useEffect(() => {
    const env = process.env.REACT_APP_ENV || 'staging'; // 환경변수

    const favicon = document.querySelector(`link[rel='icon']`) as HTMLLinkElement;

    if (favicon && env !== 'production') {
      if (type === 'admin') {
        if (env == 'pre-release') {
          favicon.href = AdminPreSvg;
        } else if (env === 'staging') {
          favicon.href = AdminSTGSvg;
        }
      } else if (type === 'client') {
        if (env == 'pre-release') {
          favicon.href = ClientPreSvg;
        } else if (env === 'staging') {
          favicon.href = ClientSTGSvg;
        }
      }
    }
  }, [type]);
};
